import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    '.block-picker': {
      boxShadow: 'none !important',
      borderRadius: '0 !important',
    },
    '.block-picker > div': {
      borderRadius: '0 !important',
    },
  },

  popoverItemTitle: {
    flexGrow: 1,
  },
  popoverPriority: {
    fontSize: 14,
    color: theme.palette.primary.main,
  },
  statusLabel: {
    display: 'inline-block',
    width: 66,
    height: 21,
    borderRadius: 3,
    lineHeight: '21px',
    color: '#fff',
    fontSize: 10,
    textAlign: 'center',
  },
  colorActive: {
    backgroundColor: theme.palette.primary.main,
  },
  colorScheduled: {
    backgroundColor: '#09c178',
  },
  colorCompleted: {
    backgroundColor: '#e0e0e0',
  },
  colorStory: {
    backgroundColor: '#ff008a',
  },
  colorSeason: {
    backgroundColor: 'grey',
  },
  colorCollection: {
    backgroundColor: '#9013fe',
  },
  colorLink: {
    backgroundColor: '#4a90e2',
  },
  colorAbtest: {
    backgroundColor: '#4051b5',
  },
  typeLabel: {
    padding: '2px 6px',
    fontSize: '9px',
    color: '#fff',
    textTransform: 'capitalize',
    marginRight: 6,
  },
  detailTitle: {
    fontSize: '0.9375rem',
    marginBottom: 6,
  },
  linkedCurationsWrap: {
    border: 'solid 1px #dcdcdc',
    marginTop: 15,
    padding: '10px 14px',
  },
  linkedCurationItem: {
    marginBottom: 8,
  },
  linkedCurationTitle: {
    flex: '0 1 auto',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    marginRight: 5,
  },
  linkedCurationUserCount: {
    flex: '0 1 auto',
    color: '#4051b5',
  },

  linkedHomeType: {
    display: 'flex',
    marginLeft: 'auto',
  },
}));

export default useStyles;
